/*
Briques visuelles de la charte v5, partagées par la homepage et les pages activité :
surfaces, titres, kicker numéroté, icônes et bandeau de logos clients.
*/

// Surfaces : une seule ombre douce et une seule bordure pour toutes les cartes.
export const CARD = 'rounded-xl border border-was-ink/8';
export const CARD_HOVER = 'transition duration-300 ease-out hover:border-was-ink/20';
export const SECTION = 'mx-auto max-w-[1240px] px-6 py-20 lg:px-8 lg:py-32';
// Titre de section : Unbounded capitales, comme sur la homepage.
export const H2 = 'text-balance text-[26px] font-heading font-extrabold uppercase tracking-[-0.01em] leading-[1.06] text-was-ink md:text-[34px]';

export const CLIENT_LOGOS = [
  ['netflix', 'Netflix', 'h-5'],
  ['dior', 'Dior', 'h-5'],
  ['lepacte', 'Le Pacte', 'h-6'],
  ['canal', 'Canal+', 'h-5'],
  ['arte', 'Arte', 'h-5'],
  ['deezer', 'Deezer', 'h-5'],
  ['brut', 'Brut', 'h-5'],
  ['kom', 'Kom', 'h-6'],
  ['chloe', 'Chloé', 'h-4'],
  ['webedia', 'Webedia', 'h-6'],
  ['francetv', 'France TV', 'h-7'],
  ['universal', 'Universal', 'h-8'],
];

export function ArrowIcon({ size = 15, strokeWidth = 2 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  );
}

export function SearchIcon({ size = 16, stroke = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </svg>
  );
}

export function PlayIcon({ size = 16, fill = '#130e1b' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} aria-hidden="true"><polygon points="8 5 20 12 8 19 8 5" /></svg>
  );
}

// Libellé de section numéroté : « 01 — Sélection de la semaine ».
export function Kicker({ n, scene, children }) {
  return (
    <div className="flex items-center gap-3 text-sm font-normal text-was-muted">
      {n && (
        <span className="tabular-nums">
          {scene}
          {' '}
          {n}
        </span>
      )}
      {n && <span className="h-px w-6 bg-was-ink/20" />}
      <span className="first-letter:uppercase">{children}</span>
    </div>
  );
}

// Bandeau de preuve : « 50 000+ productions » + défilé des logos clients.
export function ProofBand({ count, label }) {
  const logos = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section className="border-b border-was-ink/8 bg-white">
      <div className="mx-auto flex max-w-[1240px] items-center gap-6 px-6 py-6 lg:gap-10 lg:px-8 lg:py-7">
        <span className="shrink-0 text-sm text-was-muted">
          <strong className="font-bold text-was-ink">{count}</strong>
          {' '}
          {label}
        </span>
        <div className="was-mask-x relative flex-1 overflow-hidden">
          <div className="was-marquee flex w-max items-center gap-12 lg:gap-14">
            {logos.map(([file, name, hClass], i) => (
              // eslint-disable-next-line react/no-array-index-key
              <img key={`prooflogo${file}${i}`} src={`/imgv4/logos-riders/${file}.svg`} alt={i < CLIENT_LOGOS.length ? `Logo ${name}` : ''} aria-hidden={i >= CLIENT_LOGOS.length ? 'true' : undefined} className={`static ${hClass} w-auto max-w-[110px] brightness-0 opacity-35 transition-opacity duration-300 hover:opacity-70`} loading="lazy" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
